import axios from 'axios'

export default {
  getProfil: () => axios.get('/web/user/me')
}